import { faBackward } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import type { Exam } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";

export const RevertExamModal: FC<{ exam: Exam }> = (props) => {
  const { refreshAll } = useApi();
  const { revertExam } = useApiCall();
  const confirm = async () => {
    await revertExam(props.exam.id);
    await refreshAll();
  };
  return (
    <>
      <div>Je staat op het punt om het volgende examen terug te zetten.</div>
      <div className={"font-semibold my-2"}>
        &middot; <span>{props.exam.name}</span>
      </div>

      <ModalFooter text={"Terugzetten"} icon={faBackward} onSubmit={confirm} />
    </>
  );
};
